// =============================================================
// analytics.js — GA4 via gtag.js
// Replaces the dead react-ga (Universal Analytics) + Google Optimize.
//
// GA4 Measurement ID is read from REACT_APP_GA4_ID, falling back to the
// known Cloudare GA4 ID. Set REACT_APP_GA4_ID in Vercel to override.
// =============================================================

const GA4_ID = process.env.REACT_APP_GA4_ID || "G-ZFC71L9Z47";

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  if (!GA4_ID) return;

  // Inject gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // We send page_view manually on route change for SPA accuracy
  gtag("config", GA4_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
